import { make } from 'vuex-pathify'

// import dottie from 'dottie'
// import { api } from '@/api'
import questions from '@/data/questions.json'

/**
 * semantics try align with DDD
 * @see https://www.thenativeweb.io/blog/2017-10-25-09-46-ddd-and-co-part-1-whats-wrong-with-crud/
 * */

// like: initial state
const state = {
  config: {
    name: 'default',
    steps: [1, 2, 3, 4, 5]
  },
  activeStep: 1,
  activeStepKey: 'site',
  questions: []
}

// like: aggregated state
const getters = {
  ...make.getters(state),
  isLastStep(state) {
    return state.config.steps.slice(-1)[0] === state.activeStep
  },
  activeStepQuestion(state) {
    return state.questions.find((s) => s.step === state.activeStep)
  },
  getConditionalOptions(state) {
    return state.questions
      .map((q) => {
        q.optionGroups.map((e) => (e.selectionKey = q.key))
        return q.optionGroups.filter((og) =>
          Object.hasOwnProperty.call(og, 'condition')
        )
      })
      .flat()
  },
  allOptions(state) {
    return state.questions
      .map((q) => q.optionGroups.map((og) => og.options).flat())
      .flat()
  }
}

// like: fires events
const mutations = {
  listed(state, { questions }) {
    state.questions = questions.filter((q) =>
      state.config.steps.includes(q.step)
    )
  },
  listingFailed(state) {
    state.questions = []
  },
  nextStepped(state) {
    const index = state.config.steps.indexOf(state.activeStep)
    state.activeStep = state.config.steps[index + 1]
  },
  ...make.mutations(state)
}

// like: commands
const actions = {
  async list({ commit }) {
    try {
      commit('listed', { questions })
    } catch (e) {
      commit('listingFailed')
    }
  },
  nextStep({ commit }) {
    commit('nextStepped')
  }
}

// like: domain
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
